<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card mt-3">
                    <div class="card-header">
                        <h5 class="mb-0">Copy Roles from Branch</h5>
                    </div>
                    <div class="card-body">
                        <p class="text-muted">
                            Copy role(s) and their permissions from a source branch into your
                            current branch. Roles that already exist in your branch (by name)
                            are skipped.
                        </p>

                        <div class="row">
                            <div class="col-md-4 mb-3">
                                <label class="form-label">Source Branch</label>
                                <select class="form-select" v-model="sourceBranchId" @change="onSourceBranchChange">
                                    <option value="">-- Select branch --</option>
                                    <option v-for="b in branches" :key="b.id" :value="b.id">
                                        {{ b.name }}{{ (b.default_branch == 1) ? ' (Default)' : '' }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-md-4 mb-3">
                                <label class="form-label">Source Role</label>
                                <select class="form-select" v-model="sourceRoleId">
                                    <option value="">All roles</option>
                                    <option v-for="r in sourceRoles" :key="r.id" :value="r.id">{{ r.name }}</option>
                                </select>
                            </div>

                            <div class="col-md-4 mb-3 d-flex align-items-end">
                                <button class="btn btn-success" :disabled="!sourceBranchId || loading" @click="copyRoles">
                                    <span v-if="loading">Copying...</span>
                                    <span v-else>Copy</span>
                                </button>
                            </div>
                        </div>

                        <div v-if="message" class="alert mt-2" :class="isError ? 'alert-danger' : 'alert-success'">
                            {{ message }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'copy-roles-from-branch',
    data() {
        return {
            branches: [],
            sourceRoles: [],
            sourceBranchId: '',
            sourceRoleId: '',
            loading: false,
            message: '',
            isError: false,
        };
    },
    mounted() {
        this.getBranches();
    },
    methods: {
        getBranches() {
            const self = this;
            // All branches; the default branch is pre-selected as the source.
            axios.get('api/modules/user-roles/branches-for-copy')
                .then(function (response) {
                    self.branches = response.data.items || [];
                    // Default the source to the system default branch and load its roles.
                    if (response.data.default_branch_id) {
                        self.sourceBranchId = response.data.default_branch_id;
                        self.loadSourceRoles();
                    }
                })
                .catch(function (err) { console.warn(err); });
        },
        onSourceBranchChange() {
            this.sourceRoleId = '';
            this.sourceRoles = [];
            this.loadSourceRoles();
        },
        loadSourceRoles() {
            const self = this;
            if (!self.sourceBranchId) return;
            axios.get('api/modules/user-roles/by-branch', { params: { branch_id: self.sourceBranchId } })
                .then(function (response) {
                    self.sourceRoles = response.data || [];
                })
                .catch(function (err) { console.warn(err); });
        },
        copyRoles() {
            const self = this;
            self.loading = true;
            self.message = '';
            self.isError = false;
            axios.post('api/modules/user-roles/copy-from-branch', {
                source_branch_id: self.sourceBranchId,
                source_role_id: self.sourceRoleId,
            }).then(function (response) {
                self.loading = false;
                self.message = response.data.message;
            }).catch(function (err) {
                self.loading = false;
                self.isError = true;
                self.message = (err.response && err.response.data && err.response.data.message)
                    ? err.response.data.message
                    : 'Failed to copy roles.';
            });
        },
    },
};
</script>
